import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';

export default function UserCreatePage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    role: 'USER',
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/register', formData);
      alert('User created successfully');
      navigate('/admin');
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to create user');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="admin-header">
        <div>
          <h2>Create New User</h2>
          <p>Add a new user to the system</p>
        </div>
        <button className="btn-secondary" onClick={() => navigate('/admin')}>Cancel</button>
      </div>

      <div className="admin-content-card" style={{ padding: '2rem' }}>
        <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
          <div className="form-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>FULL NAME</label>
            <input 
              type="text" 
              required
              className="form-control"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
              placeholder="Enter full name"
            />
          </div>
          <div className="form-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>EMAIL ADDRESS</label>
            <input 
              type="email" 
              required
              className="form-control"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
              placeholder="Enter email address"
            />
          </div>
          <div className="form-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>PASSWORD</label>
            <input 
              type="password" 
              required
              className="form-control"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
              placeholder="Enter temporary password"
            />
          </div>
          <div className="form-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>ROLE</label>
            <select 
              className="form-control"
              value={formData.role}
              onChange={(e) => setFormData({...formData, role: e.target.value})}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
            >
              <option value="USER">User</option>
              <option value="ADMIN">Admin</option>
            </select>
          </div>
          
          <div style={{ gridColumn: '1 / -1', marginTop: '1rem' }}>
            <button type="submit" className="btn-primary" disabled={loading} style={{ padding: '0.75rem 2rem' }}>
              {loading ? 'Creating...' : 'Create User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

